import { render, staticRenderFns } from "./frontTag.vue?vue&type=template&id=d27cc728&scoped=true&"
import script from "./frontTag.vue?vue&type=script&lang=js&"
export * from "./frontTag.vue?vue&type=script&lang=js&"
import style0 from "./frontTag.vue?vue&type=style&index=0&id=d27cc728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27cc728",
  null
  
)

export default component.exports